import { render } from "./CreateCabinType.vue?vue&type=template&id=388d693f"
import script from "./CreateCabinType.vue?vue&type=script&lang=js"
export * from "./CreateCabinType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__